<template>
  <component
    :is="layout"
    v-if="layout"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Watch } from "vue-property-decorator"
import { useAcl } from "vue-simple-acl"
import { Getter } from "s-vuex-class"

import { config, isStaging } from "@/app.config"
import DefaultLayout from "@/layouts/DefaultLayout.vue"
import EmptyLayout from "@/layouts/EmptyLayout.vue"
import EmptyLayoutWithHeader from "@/layouts/EmptyLayoutWithHeader.vue"
import ErrorLayout from "@/layouts/ErrorLayout.vue"

import { ResourceType, SubscriptionDTO } from "./models"
import { BrowserTabConfig } from "./models/MetaConfigs"
import { forceUpdateToken, updateToken } from "./plugins/keycloak"
import { Getters } from "./store/getters"
import { store } from "./store/store"

@Options({
  computed: {
    config() {
      return config
    }
  },
  methods: {
    isStaging
  },
  components: {
    DefaultLayout,
    EmptyLayout,
    ErrorLayout,
    EmptyLayoutWithHeader
  },
  name: "Project Simple"
})
export default class App extends Vue {
  @Getter(Getters.SUBSCRIPTION_MESSAGE) readonly serverSendUpdated: (
    status: ResourceType
  ) => SubscriptionDTO[]

  defaultLayout = "DefaultLayout"
  triggerBrowserTabUpdate = false

  async mounted() {
    await forceUpdateToken()
  }

  async created() {
    this.setBrowserTabName()
  }

  get layout() {
    return this.$route.meta.layout || this.defaultLayout
  }

  @Watch("$route")
  routeUpdated() {
    updateToken()
    this.setBrowserTabName()
  }

  get browserTabConfig(): BrowserTabConfig {
    return this.$route.meta?.browserTabConfig as BrowserTabConfig
  }

  get browserTabGetter() {
    return this.browserTabConfig?.getter ? store.getters[Getters[this.browserTabConfig.getter]] : ""
  }

  get browserTabSecondaryGetter() {
    return this.browserTabConfig?.secondaryGetter
      ? store.getters[Getters[this.browserTabConfig.secondaryGetter]]
      : ""
  }

  get browserTabWait() {
    return this.browserTabConfig?.wait ? this.$wait.is(this.browserTabConfig.wait) : false
  }

  get accountEnabled() {
    return this.serverSendUpdated("ACCOUNT_ENABLED")
  }

  get isSuperAdmin() {
    return useAcl().can("superAdmin")
  }

  @Watch("browserTabWait")
  @Watch("browserTabGetter")
  @Watch("browserTabSecondaryGetter")
  setBrowserTabName() {
    const defaultTabName = "Project Simple"
    if (!this.browserTabConfig || this.browserTabWait) {
      document.title = defaultTabName
      return
    }

    if (typeof this.browserTabConfig.title === "function") {
      let data = {
        value: this.browserTabGetter,
        secondaryValue: this.browserTabSecondaryGetter,
        route: this.$route
      }
      const result = this.browserTabConfig.title(data)

      document.title = result ? result : defaultTabName
    } else {
      document.title = this.browserTabConfig.title
    }
  }

  @Watch("accountEnabled")
  onAccountEnabledChange() {
    if (!this.isSuperAdmin && this.accountEnabled?.some(e => e.type === "ACCOUNT_ENABLED")) {
      window.location.reload()
    }
  }
}
</script>
